import { render, staticRenderFns } from "./DataLoggerAutcomplete.vue?vue&type=template&id=1df32081&scoped=true&"
import script from "./DataLoggerAutcomplete.vue?vue&type=script&lang=js&"
export * from "./DataLoggerAutcomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df32081",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
